import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {FuseUtils, FuseAnimate} from '@fuse';
import {bindActionCreators} from 'redux';
import {Button, Icon, IconButton, Tooltip, Typography, Select, MenuItem} from '@material-ui/core';
import ReduxGlobal from "../../../../store/actionreducers/globalView";
import ReduxCompany from '../../../../store/actionreducers/company';
import ReactTable from "react-table";
import classNames from 'classnames';
import mime from 'mime-types';
import {constDataDialogs} from "../../../../constants";

class CompanyList extends Component {

    state = {
        selectedContactsMenu: null
    };

    getFilteredArray = (entities, searchText) => {
        const arr = Object.keys(entities).map((id) => entities[id]);
        if (searchText.length === 0) {
            return arr;
        }
        return FuseUtils.filterArrayByString(arr, searchText);
    };

    downloadFile({base64File, fileName}) {
        const link = document.createElement("a");
        const fileExtension = mime.extension(/^data:(.*?);base64,/.exec(base64File)[1]);
        link.download = `${fileName}.${fileExtension}`;
        link.href = base64File;
        link.click();
    }

    render() {
        const {classes, companies, searchText, getCompany} = this.props;
        const {openDataDialog, deleteCompany, getCompanies, openAlertDialog, openLoadingMask, closeLoadingMask} = this.props;

        const data = this.getFilteredArray(companies, searchText);

        if (!data && data.length === 0) {
            return (
                <div className="flex items-center justify-center h-full">
                    <Typography color="textSecondary" variant="headline">
                        目前沒有任何公司
                    </Typography>
                </div>
            );
        }

        return (
            <FuseAnimate animation="transition.slideUpIn" delay={300}>
                <ReactTable
                    filterable
                    previousText='Previous'
                    nextText='Next'
                    loadingText='Loading...'
                    noDataText="目前沒有任何公司"
                    pageText='頁'
                    ofText='/共'
                    rowsText='筆'
                    className={classNames(classes.root, "-striped -highlight")}
                    getTrProps={(state, rowInfo, column) => {
                        return {
                            className: "cursor-pointer",
                            onClick: async (e, handleOriginal) => {
                                if (rowInfo) {
                                    try {
                                        const companyId = rowInfo.original.id;
                                        await getCompany(companyId);
                                        openDataDialog({
                                            type: constDataDialogs.type.edit,
                                            name: constDataDialogs.name.companyDialog
                                        });
                                    } catch (e) {
                                        console.warn('you got an error = ', e);
                                    }
                                }
                            }
                        }
                    }}
                    data={
                        data.sort(function (preCompany, currCompany) {
                            return currCompany.id - preCompany.id;
                        })
                    }
                    columns={[
                        {
                            Header: "名稱",
                            accessor: "name",
                            filterable: true,
                            className: "font-bold"
                        },
                        {
                            Header: "統一編號",
                            accessor: "no",
                            filterable: true
                        },
                        {
                            Header: "聯絡人",
                            accessor: "main_vip.user.name",
                            filterable: true
                        },
                        {
                            Header: "開通人數",
                            accessor: "current_members",
                            filterable: true
                        },
                        {
                            Header: "合約",
                            className: "font-bold",
                            Cell: row => {
                                const contract = row.original.contract;
                                const companyName = row.original.name;
                                const fileName = `${companyName}_合約書`;
                                return (contract) ?
                                    (<div>
                                        <Button id='download_contract'
                                                name='download_contract'
                                                className={classes.button}
                                                variant="raised"
                                                color="secondary"
                                                onClick={(ev) => {
                                                    ev.stopPropagation(); // 不打開 dialog
                                                    this.downloadFile({base64File: contract, fileName});
                                                }}>
                                            下載合約
                                        </Button>
                                    </div>)
                                    :
                                    (<div>沒有合約</div>);
                            },
                            filterMethod: (filter, row) => {
                                const contract = row._original.contract;
                                if (filter.value === "true") {
                                    return contract;
                                } else if (filter.value === "false") {
                                    return !contract;
                                } else {
                                    return true;
                                }
                            },
                            Filter: ({filter, onChange}) => (
                                <Select
                                    value={filter ? filter.value : "all"}
                                    style={{width: "100%"}}
                                    onChange={event => onChange(event.target.value)}
                                    name="selectContract"
                                >
                                    <MenuItem value="all">顯示全部</MenuItem>
                                    <MenuItem value="true">有合約</MenuItem>
                                    <MenuItem value="false">沒合約</MenuItem>
                                </Select>
                            )
                        },
                        // {
                        //     Header: () => <div>點數<br/>紀錄</div>,
                        //     width: 64,
                        //     filterable: false,
                        //     Cell: row => (
                        //         <div className="flex items-center">
                        //             <IconButton
                        //                 onClick={async (ev) => {
                        //                     ev.stopPropagation();
                        //                     const companyId = row.original.id;
                        //                     this.props.history.push({
                        //                         pathname: `/cc/company/${companyId}/useRecord`,
                        //                         state: {redirectUrl: this.props.location.pathname}
                        //                     });
                        //                 }}
                        //             >
                        //                 <Icon className={"text-teal-darker"}>search</Icon>
                        //             </IconButton>
                        //         </div>
                        //     )
                        // },
                        {
                            Header: () => (
                                <div>
                                    <Tooltip title="如果企業中有群組帳戶 , 此企業無法刪除" classes={{tooltip: classes.tooltip}}>
                                        <div>刪除</div>
                                    </Tooltip>
                                </div>
                            ),
                            width: 64,
                            filterable: false,
                            Cell: row => {
                                const company = row.original;
                                const groups = company.groups || [];

                                const alertDialogInfo = {
                                    title: '刪除企業',
                                    message: `請問您要刪除企業(${company.name})嗎?`,
                                    yesButton: {
                                        label: '是',
                                        onClick: async () => {
                                            try {
                                                openLoadingMask();
                                                await deleteCompany(row.original.id); // delete company
                                                await getCompanies();
                                                closeLoadingMask();
                                            } catch (e) {
                                                console.warn('you got an error = ', e);
                                            }
                                        },
                                    },
                                    noButton: {label: '否'}
                                };

                                if (groups.length > 0) return <div className="flex items-center"/>;
                                else {
                                    return (<div className="flex items-center">
                                        <IconButton
                                            onClick={async (ev) => {
                                                ev.stopPropagation();
                                                openAlertDialog(alertDialogInfo);
                                            }}
                                        >
                                            <Icon>delete</Icon>
                                        </IconButton>
                                    </div>)
                                }
                            }
                        },
                    ]}
                    defaultPageSize={5}
                />
            </FuseAnimate>
        );
    }
}

const styles = theme => ({
    avatar: {
        backgroundColor: theme.palette.primary[500]
    },
    labels: {},
    tooltip: {
        maxWidth: 100,
    }
});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getCompany: ReduxCompany.ActionCreator.getCompany,
        getCompanies: ReduxCompany.ActionCreator.getCompanies,
        openAlertDialog: ReduxGlobal.ActionCreator.openAlertDialog,
        deleteCompany: ReduxCompany.ActionCreator.deleteCompany,
        openDataDialog: ReduxGlobal.ActionCreator.openDataDialog,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
    }, dispatch);
}

function mapStateToProps({company: {companies}, global: {searchText}}) {
    return {companies, searchText,};
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(CompanyList)));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/company/CompanyList.js